export default __webpack_public_path__ + "static/media/FontsFree-Net-SFProText-Semibold-1.fee27977.ttf";